import React from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { Col, Modal, Row } from "react-bootstrap";
import { Button } from "@atoms";
import StarRatingComponent from "react-star-rating-component";

const ReviewDetailModal: React.FC<IProps> = (
  {
    show,
    onHide,
    title,
    rating,
    comment,
    imgSrcs
  }: IProps) => {

  return (
    <S.Wrapper>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
      >
        <Modal.Header closeButton>
          {title}
        </Modal.Header>
        <Modal.Body>
          <StarRatingComponent
            name="ReviewRating"
            editing={false}
            starCount={5}
            starColor="#F39"
            emptyStarColor="#BFBFBF"
            value={rating}
          />
          <p>
            {comment}
          </p>
          {imgSrcs.map((src, j) => {
            return (
              // TODO 모달 뷰 처리
              <S.ReviewImage key={j} src={src}/>
            )
          })}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onHide}>close</Button>
        </Modal.Footer>
      </Modal>
    </S.Wrapper>
  )
};

export { ReviewDetailModal }